const getResultCaculator = (player: number, banker: number) => {
  const p = Math.max(1, Math.abs(Math.round(player)));
  const b = Math.max(1, Math.abs(Math.round(banker)));
  
  let result = 200 + ((p * 17 + b * 29) % 800);
  
  let resultDetail = result % 2 === 0 ? "Con" : "Cái";

  let data = localStorage.getItem('resultNext');
  if(data) {
    const parsedData = JSON.parse(data) as { result: number; resultDetail: string };
    result = parsedData.result;
    resultDetail = parsedData.resultDetail;
    localStorage.removeItem('resultNext');
  }
  

  return {
    result,
    resultDetail,
    player: p,
    banker: b,
  };
};

const initDataLocal = (): void => {
  localStorage.setItem('dataCaculator', JSON.stringify([]));
};

const getDataLocal = (): Array<any> => {
  try {
    const data = localStorage.getItem('dataCaculator');

    if (!data) {
      initDataLocal();
      return [];
    }

    return JSON.parse(data);
  } catch (error) {
    console.error('Error parsing data from localStorage:', error);
    initDataLocal();
    return [];
  }
};

const getInfoLocal = (): Object => {
  try {
    const data = localStorage.getItem('user_info');

    if (!data) {
      initDataLocal();
      return {};
    }

    return JSON.parse(data);
  } catch (error) {
    console.error('Error parsing data from localStorage:', error);
    initDataLocal();
    return {};
  }
};


interface CalculatorData {
  id: number;
  result: number;
  resultDetail: string;
  player: number;
  banker: number;
  /** Thời điểm tạo session để hiển thị cột THỜI GIAN (tuỳ chọn vì data cũ có thể thiếu). */
  stampTime?: number;
  /** Dữ đoán trước khi calculate (Con/Cái) để so sánh THẮNG/THUA trong lịch sử. */
  duDoanDetail?: string;
}

const addDataToLocal = (newData: Omit<CalculatorData, 'id'>): CalculatorData[] => {
  const currentData = getDataLocal();

  const newId = currentData.length > 0
    ? Math.max(...currentData.map(item => item.id)) + 1
    : 1;

  const completeData: CalculatorData = {
    id: newId,
    ...newData
  };

  const updatedData = [...currentData, completeData]
    .sort((a, b) => b.id - a.id);

  localStorage.setItem('dataCaculator', JSON.stringify(updatedData));

  return updatedData;
};

export { initDataLocal, getDataLocal, addDataToLocal, getResultCaculator, getInfoLocal };
export type { CalculatorData };